import BaseModel from "models/BaseModel";

export default class ModuleCardholderApplicantModel extends BaseModel {}
